const PageHeader = ({ label, children }) => {
  return (
    <div className="flex items-center justify-between border-b border-solid border-brand-header-border mb-4 mt-2 lg:mt-0 pb-4 lg:pb-2.5">
      <h2 className="text-lg md:text-xl font-semibold mt-4">{label}</h2>
      {children && (
        <div className="flex items-center gap-3 flex-shrink-0 mt-2">
          {children}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
